import {Radio, RadioChangeEvent, Flex} from "antd";
import { useAppSettings } from "~context/AppSettingsContext/AppSettingsContext.tsx";
import { useIntl } from "react-intl";

export const DisplayWidth = () => {
  const {displayWidthConstrained, toggleConstrained} = useAppSettings()
  const onChange = (e: RadioChangeEvent) => {
    toggleConstrained(e.target.value);
  };

  const {formatMessage} = useIntl();


  return (
    <div>
      <div className="app-settings-content-block-title">{formatMessage({id: "app.settings.display.width.title"})}</div>
      <Radio.Group
        onChange={onChange}
        className={'display-width-radio-group'}
        value={displayWidthConstrained}
        options={[
          {
            value: true,
            label: (
              <Flex gap="small" justify="space-between" align="center" className="display-width-option">
                <div className="display-width-option-title">{formatMessage({id: "app.settings.display.width.default"})}</div>
                <Flex justify="center" align="center" className="display-width-box">
                  <div className="display-width-box-content-default"></div>
                </Flex>
              </Flex>
            ),
          },
          {
            value: false,
            label: (
              <Flex gap="small" justify="space-between" align="center" className="display-width-option">
                <div className="display-width-option-title">{formatMessage({id: "app.settings.display.width.full"})}</div>
                <Flex justify="center" align="center" className="display-width-box">
                  <div className="display-width-box-content-full"></div>
                </Flex>
              </Flex>
            ),
          },
        ]}>
      </Radio.Group>
    </div>
  )
}